import { useState, useCallback } from 'react';
import { getAgentDetails } from '../../../services/AgentsServices';

const useAgentHub = (agentId) => {
  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [stats, setStats] = useState({
    totalProducts: 0,
    totalDocs: 0,
    totalAutomations: 0
  });

  const loadAgentData = useCallback(async () => {
    if (!agentId) return;

    try {
      setLoading(true);
      setError(null);


      // Carregar dados do agente
      const agentResponse = await getAgentDetails(agentId);
      
      
      if (agentResponse.success) {
        const agentData = agentResponse.data;
        setAgent(agentData);
        
        // Extrair ou calcular estatísticas do agente
        // Essas informações podem vir da API ou serem calculadas
        setStats({
          totalProducts: agentData.products_count || 0,
          totalDocs: agentData.documents_count || 0,
          totalAutomations: agentData.automations_count || 0
        });

        console.log('✅ Dados do agente carregados com sucesso');
      } else {
        const errorMsg = agentResponse.error || 'Erro ao carregar dados do agente';
        console.error('❌ Erro na resposta da API:', errorMsg);
        setError(errorMsg);
      }
    } catch (err) {
      console.error('❌ Erro inesperado ao carregar dados do agente:', err);
      
      // Tratar diferentes tipos de erro
      let errorMessage = 'Erro inesperado ao carregar dados do agente';
      
      if (err.response) {
        // Erro da API
        const { status, data } = err.response;
        switch (status) {
          case 404:
            errorMessage = 'Agente não encontrado';
            break;
          case 403:
            errorMessage = 'Você não tem permissão para acessar este agente';
            break;
          case 500:
            errorMessage = 'Erro interno do servidor. Tente novamente em alguns minutos.';
            break;
          default:
            errorMessage = data?.message || data?.error || errorMessage;
        }
      } else if (err.request) {
        // Erro de rede
        errorMessage = 'Erro de conexão. Verifique sua internet e tente novamente.';
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [agentId]);

  // Função para atualizar estatísticas (pode ser chamada pelos componentes filhos)
  const updateStats = useCallback((newStats) => {
    setStats(prevStats => ({
      ...prevStats,
      ...newStats
    }));
  }, []);

  // Função para recarregar dados do agente
  const refreshAgentData = useCallback(() => {
    loadAgentData();
  }, [loadAgentData]);

  return {
    agent,
    loading,
    error,
    activeTab,
    setActiveTab,
    stats,
    updateStats,
    loadAgentData,
    refreshAgentData
  };
};

export default useAgentHub;